import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function ProtectedRoute() {
  const location = useLocation();

  const getToken = () => {
    const t =
      localStorage.getItem("access_token") ??
      sessionStorage.getItem("access_token") ??
      localStorage.getItem("token") ??
      sessionStorage.getItem("token");

    if (!t) return null;
    const s = String(t).trim();
    if (s === "" || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") {
      return null;
    }
    return s;
  };

  const token = getToken();

  React.useEffect(() => {
    console.log("ProtectedRoute check:", {
      tokenValue: token,
      access_local: localStorage.getItem("access_token"),
      access_sess: sessionStorage.getItem("access_token"),
      token_local: localStorage.getItem("token"),
      token_sess: sessionStorage.getItem("token"),
    });
  }, [token]);

  if (!token) {
    localStorage.removeItem("access_token");
    sessionStorage.removeItem("access_token");
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");

    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
